
import React from 'react';

interface FilterButtonProps {
    label: string;
    isSelected: boolean;
    onClick: () => void;
}

const PostCardFilterContainer: React.FC<FilterButtonProps> = ({ label, isSelected, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`flex justify-center items-center rounded-[100px] w-[90px] h-[48px] md:h-[38px] md:w-[70px]
    ${isSelected ? 'bg-main' : 'bg-white border border-black'}`}
        >
  <span
      className={`font-namsan text-lg md:text-sm font-semibold 
      ${isSelected ? 'text-white' : 'text-black'}`}
  >
    {label}
  </span>
        </button>

    );
};

export default PostCardFilterContainer;
